import './MenuStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { menu as menuConstants } from 'src/constants';

import { MenuGroup, MenuItem } from './components';
import messages from './messages';

const MenuComponent = ({
  selectedMenuItem,
  onSelectMenuItem,
  menuGroups,
  isViewAllActive,
}) => (
  <div className="mcp-menu">
    <MenuItem
      label={messages.viewAllMenuItem}
      category={{ name: menuConstants.VIEW_ALL }}
      selectedMenuItem={selectedMenuItem}
      onSelectMenuItem={onSelectMenuItem}
      isViewAllActive={isViewAllActive}
    />
    {menuGroups.map((group, index) => (
      <MenuGroup
        key={index}
        group={group}
        selectedMenuItem={selectedMenuItem}
        onSelectMenuItem={onSelectMenuItem}
      />
    ))}
  </div>
);

MenuComponent.propTypes = {
  selectedMenuItem: PropTypes.object,
  onSelectMenuItem: PropTypes.func,
  menuGroups: PropTypes.array.isRequired,
  isViewAllActive: PropTypes.bool,
};

export default MenuComponent;
